<template>
  <div class="container">
    <header class="header">
      <h1>Zack Ensign <span>/ Developer</span></h1>
      <nav>
        <ul>
          <li><a href="#about">About</a></li>
          <li><a href="#experience">Experience</a></li>
          <li><a href="#education">Education</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </nav>
    </header>
  </div>
</template>

<script>
export default {
  name: 'SiteHeader'
}
</script>
